'use strict';

const setCampaigns = (state, campaigns = []) => {
  state.availableCampaigns = campaigns;
};

export default {
  setCampaigns
};
